import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b92d179c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "checked", "disabled", "autofocus"]
const _hoisted_2 = {
  key: 1,
  title: "Required Field"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - Optional field")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("abbr", null, "*", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["name", "value", "required"]
const _hoisted_8 = ["type", "name", "checked", "value", "disabled", "autofocus", "onInput", "onKeyup[0]", "onKeyup[1]"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_button = _resolveComponent("vue-button")!
  const _component_input_response = _resolveComponent("input-response")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkboxInput", { inline: _ctx.inline }])
  }, [
    (_ctx.label || (_ctx.type == 'checkbox' && !_ctx.options?.length))
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ maskField: _ctx.mask, checked: !_ctx.options?.length && _ctx.value })
        }, [
          (_ctx.type !== 'radio' && !_ctx.options?.length && !_ctx.mask)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                ref: "singleCheckbox",
                type: "checkbox",
                name: _ctx.tag,
                checked: _ctx.value,
                disabled: _ctx.isDisabled,
                autofocus: _ctx.autofocus,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.check(_ctx.value))),
                "onKeyup[0]": _cache[1] || (_cache[1] = ($event: any) => (_ctx.check(_ctx.value))),
                "onKeyup[1]": _cache[2] || (_cache[2] = ($event: any) => (_ctx.check(_ctx.value)))
              }, null, 40, _hoisted_1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("abbr", _hoisted_2, "*"))
            : (_ctx.options)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true),
          _createElementVNode("input", {
            name: _ctx.tag,
            type: "hidden",
            value: _ctx.value,
            required: _ctx.isRequired
          }, null, 8, _hoisted_7),
          (_ctx.options?.length && _ctx.value)
            ? (_openBlock(), _createBlock(_component_vue_button, {
                key: 3,
                id: "clearSelection",
                tag: "resetValue",
                text: "Reset",
                category: "text-sm",
                ctx: _ctx.clearSelection.bind(this)
              }, null, 8, ["ctx"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.options)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({
				box: _ctx.box,
				warningContainer: _ctx.alert ? _ctx.alert.warning : false,
				errorContainer: _ctx.alert ? _ctx.alert.error : false,
				maskField: _ctx.mask,
				inline: _ctx.inline
			})
        }, [
          (!_ctx.mask)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.options, (option, index) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: index,
                  class: _normalizeClass({
						errorLabel: _ctx.alert ? _ctx.alert.error : false,
						checked: _ctx.value.includes(option)
					}),
                  style: _normalizeStyle({
						'color: #aaaaaa; cursor: not-allowed;': _ctx.disabled
					})
                }, [
                  _createElementVNode("input", {
                    ref: 
							el => {
								_ctx.checkbox[index] = el;
							}
						,
                    type: _ctx.type,
                    name: option,
                    checked: 
							_ctx.value && _ctx.type == 'checkbox'
								? _ctx.value.includes(option)
								: option == _ctx.value
						,
                    value: option,
                    disabled: _ctx.isDisabled,
                    autofocus: index == 0 ? _ctx.autofocus : false,
                    onInput: ($event: any) => (_ctx.check(option)),
                    "onKeyup[0]": ($event: any) => (_ctx.check(option)),
                    "onKeyup[1]": ($event: any) => (_ctx.check(option))
                  }, null, 40, _hoisted_8),
                  _createTextVNode(" " + _toDisplayString(option), 1)
                ], 6))
              }), 128))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_input_response, {
      warning: _ctx.alert ? _ctx.alert.warning : '',
      error: _ctx.alert ? _ctx.alert.error : '',
      info: _ctx.alert ? _ctx.alert.info : '',
      success: _ctx.alert ? _ctx.alert.success : ''
    }, null, 8, ["warning", "error", "info", "success"])
  ], 2))
}